<template>
  <v-container grid-list-xl text-xs-left>
    <p align="center">Click anywhere on the cards to learn more about each project.</p>
    <v-layout wrap>
      <v-flex sm4 xs12 v-for="project in projects" :key="project.title">
        <v-hover>
          <project-card
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 8 : 2}`"
            :project="project"
            @click="click"
          />
        </v-hover>
      </v-flex>
    </v-layout>

    <project-dialog
      :project="activeProject"
      :dialog="dialog"
      @close="dialog = false" />
  </v-container>
</template>

<script>
import ProjectCard from '@/components/projects/ProjectCard.vue';
import ProjectDialog from '@/components/projects/ProjectDialog.vue';
import projects from '@/assets/data/projects.json';

export default {
  components: {
    'project-card': ProjectCard,
    'project-dialog': ProjectDialog,
  },

  data() {
    return {
      projects,
      dialog: false,
      activeProject: {},
    };
  },

  methods: {
    click(project) {
      this.activeProject = project;
      this.dialog = true;
    },
  },
};
</script>
